import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';

export const PageIcons = {
  Add: AddIcon,
  Edit: EditIcon,
  Delete: DeleteIcon,
  View: VisibilityIcon,
  Close: CloseIcon,
  Back: ArrowBackIcon,
  Search: SearchIcon,
  Save: SaveIcon,
  Refresh: RefreshIcon,
};
